<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="
        bg-primary 
        text-white 
        border-0 
        font-weight-bold 
        p-3 
        d-flex 
        align-items-center
      ">Permintaan Pembatalan  {{ this.title_tab }}
    </CCardHeader>
    
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/keuangan/permintaan-pembatalan/sertifikasi-reguler"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          @click.native="('Sertifikasi Reguler')"
          aria-controls="home"
          aria-selected="true">Sertifikasi Reguler</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/keuangan/permintaan-pembatalan/sertifikasi-rpl"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="webinar-tab"
          data-toggle="tab"
          href="#webiner"
          role="tab"
          @click.native="('Sertifikasi RPL')"
          aria-controls="home"
          aria-selected="false">Sertifikasi RPL</router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/keuangan/permintaan-pembatalan/pelatihan"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          @click.native="('Pelatihan')"
          aria-controls="profile"
          aria-selected="false"> Pelatihan</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/keuangan/permintaan-pembatalan/iuran-keanggotaan"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          @click.native="('Iuran Keanggotaan')"
          aria-controls="profile"
          aria-selected="false">Iuran Keanggotaan</router-link>
      </li>      
    </ul>

    <!-- Data RPL-->
    <router-view></router-view>
    <!-- End Data RPL -->
  </CCard>
</template>

<script>
export default {
  name: "Master Sertifikasi RPL",
  data() {
    return {
        title_tab : 'Sertifikasi Reguler',
    };
  },
  mounted() {
    this.mountedchange(this.$router.currentRoute.path)
  },
  methods: {
    mountedchange(value) {
      switch (value) {
          case '/keuangan/permintaan-pembatalan/sertifikasi-reguler':
              this.title_tab = 'Sertifikasi Reguler';
              break;
          case '/keuangan/permintaan-pembatalan/sertifikasi-rpl':
              this.title_tab = 'Sertifikasi RPL';
              break;
          case '/keuangan/permintaan-pembatalan/pelatihan':
              this.title_tab = 'Pelatihan';
              break;
          case '/keuangan/permintaan-pembatalan/iuran-keanggotaan':
              this.title_tab = 'Iuran Keanggotaan';
              break;
          default:
              break;
      }
    }
  }
};
</script>